/** @jsxImportSource @emotion/react */
import React, { FC, memo } from 'react';
import { useTranslation } from 'react-i18next';
import { LoadingButton } from '@mui/lab';
import { Button, Dialog, DialogActions, DialogTitle } from '@mui/material';
import { TXT_CONFIRM_REMOVE_ORDER_TITLE, TXT_NO, TXT_YES } from 'translations';
import { Props } from './types';

const CheckoutDeleteOrderDialog: FC<Props> = ({
  open,
  onClose,
  onConfirm,
  isLoading,
}) => {
  const paperProps = { style: { backgroundColor: 'darkslategrey' } };
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose} PaperProps={paperProps}>
      <DialogTitle>{t(TXT_CONFIRM_REMOVE_ORDER_TITLE)}</DialogTitle>

      <DialogActions>
        <Button
          onClick={onClose as React.MouseEventHandler<HTMLButtonElement>}
          disabled={isLoading}
          variant="outlined"
        >
          {t(TXT_NO)}
        </Button>

        <LoadingButton
          onClick={onConfirm}
          loading={isLoading}
          variant="contained"
        >
          {t(TXT_YES)}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default memo(CheckoutDeleteOrderDialog);
